import store from 'store'

const USER_KEY = 'user_key'

const object = {
    setUser(user) {
        /* save User */
        //localStorage.setItem(USER_KEY, JSON.stringify(user)) // 有些瀏覽器不支援HTML5
        store.set(USER_KEY, user)
    },
    getUser() {
        /* read User */
        //return JSON.parse(localStorage.getItem(USER_KEY) || '{}'); // 有些瀏覽器不支援HTML5
        return store.get(USER_KEY) || {}
    },
    removeUser() {
        /* delete User */
        //localStorage.removeItem(USER_KEY); // 有些瀏覽器不支援HTML5
        store.remove(USER_KEY)
    }
}
export default object